<div class="mt-4 mb-4">
  <h6 i18n>Special considerations</h6>
  <p class="text-muted" i18n>
    Describe property features and potential safety risks for all guests. This text appears in your Airbnb listing
    description.
  </p>
  <p class="text-muted" i18n>This text does not change Instant Book or Request to Book settings.</p>
  <mat-form-field2 class="mat-block">
    <mat-select
      [ngModel]="locale"
      (ngModelChange)="changeLocale($event)"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="isSaving"
      placeholder="Description language"
      i18n-placeholder
    >
      <mat-option *ngFor="let item of locales" [value]="item.id">{{ item.name }}</mat-option>
    </mat-select>
  </mat-form-field2>
  <p *ngIf="isLoading" role="status" i18n>Loading special considerations...</p>
  <div *ngIf="loadFailed" class="alert alert-warning" role="alert">
    <p i18n>Unable to load this language. Load the current text before you make changes.</p>
    <button class="btn btn-secondary-info" type="button" (click)="load()" i18n>Retry</button>
  </div>
  <mat-form-field2 class="mat-block subscript-static">
    <textarea
      matInput
      [(ngModel)]="text"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="!canEdit"
      [attr.aria-invalid]="characterCount > 300"
      aria-describedby="airbnb-special-considerations-length"
      rows="3"
      placeholder="Special considerations (optional)"
      i18n-placeholder
    ></textarea>
    <mat-hint align="end" id="airbnb-special-considerations-length">{{ characterCount }}/300</mat-hint>
  </mat-form-field2>
  <p *ngIf="characterCount > 300" class="text-danger" role="alert" i18n>Enter 300 characters or fewer.</p>
  <div class="d-flex align-items-center gap-3">
    <button class="btn btn-secondary-info" type="button" (click)="save()" [disabled]="!canSave">
      <ng-container *ngIf="!isSaving" i18n>Save special considerations</ng-container>
      <ng-container *ngIf="isSaving" i18n>Saving...</ng-container>
    </button>
    <small class="text-muted" i18n
      >Save this text separately from the booking settings. Empty text removes it for this language.</small
    >
  </div>
</div>
